module.exports = __webpack_public_path__ + "img/action-plan-task.33ba7e94.png";